///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { ProgressServiceConfig } from '../../core/data/progress-service-config';
import { DpTransparentKorisnik } from './korisnik.model';

export function getKorisnikConfig(): ProgressServiceConfig {
    return {
        dataProviderName: 'dpTransparent',
        serverOperations: false,
        createModel: () => new DpTransparentKorisnik(),
        jsdo: {
            name: 'Korisnik',
        },
        ds: {},
    };
}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/data/dp-transparent/korisnik.config.ts